import React from "react";
import s from './Setting.module.css'

const Setting = (props) => {
    return (
        <div className={s.item}>
            Setting
        </div>
    )
}

export default Setting;